var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.locales.length > 1)?_c('b-nav-item-dropdown',{staticClass:"locale-switcher",attrs:{"text":_vm.currentLocale,"right":""}},_vm._l((_vm.otherLocales),function(locale){return _c('b-dropdown-item',{key:locale,on:{"click":function($event){_vm.currentLocale = locale}}},[_vm._v(" "+_vm._s(_vm.$t(`locales.${locale}`))+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }